




































































































































































import { Component, Vue } from "vue-property-decorator";
@Component({
    name: "ButtonNine"
})
export default class ButtonNine extends Vue { }
